// extracted by mini-css-extract-plugin
export var standaloneTable = "_fj-0";
export var standaloneTableWithBodyFill = "_fj-1";
export var withExtraHeader = "_fj-2";